import { useTranslation } from "react-i18next";
import { AppBar, Drawer } from "../../../../../../components";
import { envChangeType } from "../../../../../../plugins/utils";
import allianceBn from "../../icon/bg_bn.webp";
import allianceEn from "../../icon/bg_en.webp";
import upper from "../../icon/upperbg.webp";
import styles from "./style.module.scss";
const AllianceDrawer = ({ open, onClose }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const bannerImageMap = {
    bn: allianceBn,
    en: allianceEn,
  };
  const bannerSrc = bannerImageMap[i18n.language] || bannerImageMap.en;

  const renderContent = () => {
    return (
      <div className={`${styles.allianceDrawerContainer} alliance-drawer-container`}>
        <AppBar
          showBackButton={true}
          iconClosePadding={"4px"}
          onClickEvent={() => {
            onClose();
          }}
        />
        <div className={styles.allianceDrawerContent}>
          <section className={`${styles.section} ${styles.heroSection}`}>
            <div className={styles.bannerWrapper}>
              <img className={styles.banner} src={bannerSrc} alt="alliance-banner" />
              <img className={styles.upperBanner} src={upper} alt="alliance-upper-banner" />
            </div>
            <button className={styles.registerBtn} type="button" onClick={onClose}>
              👉{t("alliance.btn.text")}
            </button>
            <div className={styles.card}>
              <h3>
                {t("alliance.heroSection.title", {
                  name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
                })}
              </h3>
              <p>
                {t("alliance.heroSection.content", {
                  name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
                })}
              </p>
              <h4 className={styles.cardGradientTitle}>
                <span>
                  {t("alliance.heroSection.subtitle1", {
                    name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
                  })}
                </span>
              </h4>
              <h4 className={styles.cardGradientTitle}>
                <span>
                  {t("alliance.heroSection.subtitle2", {
                    name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
                  })}
                </span>
              </h4>
            </div>
          </section>

          <section className={`${styles.section}`}>
            <h4>{t("alliance.section1.title")}</h4>
            <div dangerouslySetInnerHTML={{ __html: t("alliance.section1.content") }} />
          </section>

          <section className={`${styles.section} ${styles.benefitSection}`}>
            <h4>{t("alliance.section2.title")}</h4>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    {Array.from({ length: 4 }).map((_, index) => (
                      <th key={index}>{t(`alliance.table1.thead${index + 1}`)}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 6 }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                      {Array.from({ length: 4 }).map((_, index) => (
                        <td key={index}>
                          {t(`alliance.table1.tbody${index + 1}.row${rowIndex + 1}`)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className={styles.text}>{t("alliance.section2.hint")}</div>
          </section>
          <div className={`${styles.section}`}>
            <h4>{t("alliance.section3.title")}</h4>
            <div dangerouslySetInnerHTML={{ __html: t("alliance.section3.content") }} />
          </div>

          <section className={`${styles.section} ${styles.ruleSection}`}>
            <h4>{t("alliance.section4.title")}</h4>
            <div className={styles.text} style={{ margin: "10px 0" }}>
              {t("alliance.section4.subtitle1")}
            </div>

            <div className={styles.text}>{t("alliance.section4.subtitle2")}</div>
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    {Array.from({ length: 7 }).map((_, index) => (
                      <th key={index}>{t(`alliance.table2.thead${index + 1}`)}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 3 }).map((_, rowIndex) => (
                    <tr key={rowIndex}>
                      {Array.from({ length: 7 }).map((_, index) => (
                        <td key={index}>
                          {t(`alliance.table2.tbody${index + 1}.row${rowIndex + 1}`)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
          <section className={`${styles.section}`}>
            <h4>{t("alliance.section5.title")}</h4>
            <div
              dangerouslySetInnerHTML={{
                __html: t("alliance.section5.content", {
                  name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY"),
                }),
              }}
            />
          </section>
          <footer>
            {t("alliance.footer", { name: envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY") })}
          </footer>
        </div>
      </div>
    );
  };

  return (
    <Drawer
      placement={"right"}
      isClosable={false}
      onClose={onClose}
      showDrawer={open}
      destroyOnClose={true}
      width={"100%"}
      renderContent={renderContent}
    />
  );
};

export default AllianceDrawer;
